import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { isNative } from "@/lib/isNativePlatform";
import { useAppUpdate } from "@/lib/appUpdate/store";
import { reloadIfUpdatePending } from "@/lib/appUpdate/reloadPolicy";
import { startAppUpdateWatcher } from "@/lib/appUpdate/watcher";
import { UrgentUpdateBanner } from "./UrgentUpdateBanner";

/**
 * Coupé en dev (pas de version.json) et dans les apps natives, qui embarquent
 * leur propre copie du code et se mettent à jour par les boutiques.
 */
export function shouldWatch(isDev: boolean = import.meta.env.DEV, native: boolean = isNative()): boolean {
  return !isDev && !native;
}

/** Monté une fois, DANS le routeur (App.tsx). Voir src/lib/appUpdate/. */
export function AppUpdateWatcher({ enabled = shouldWatch() }: { enabled?: boolean }) {
  const location = useLocation();
  const isFirstLocation = useRef(true);
  const { status } = useAppUpdate();

  useEffect(() => {
    if (!enabled) return;
    return startAppUpdateWatcher();
  }, [enabled]);

  // Moment sûr « changement de page » pour les écrans pilotés par l'adresse
  // (admin, historique client). Le tableau de bord propriétaire change de
  // module sans toucher l'adresse : il appelle reloadIfUpdatePending lui même.
  useEffect(() => {
    if (isFirstLocation.current) {
      isFirstLocation.current = false;
      return;
    }
    if (enabled) reloadIfUpdatePending("navigation");
  }, [location.pathname, location.search, enabled]);

  return status === "urgent" ? <UrgentUpdateBanner /> : null;
}
